import { render } from "./TopNavigation.vue?vue&type=template&id=fb8012f8"
import script from "./TopNavigation.vue?vue&type=script&lang=js"
export * from "./TopNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__